import { useEffect, useState } from "react";

// Build-version badge pinned to the viewport's BOTTOM-LEFT corner — matching
// taco and the auth service. `fixed` (out of normal flow) is what puts it in
// the actual corner rather than "near" it; `pointer-events-none` so it never
// intercepts clicks. Sourced from the public /v1/version endpoint (a DB-free
// build stamp, mirroring auth/taco). Hidden until it resolves.
//
// Exported as `Footer` for the existing import in routes/root.tsx — note it is
// a corner badge, not an in-flow footer bar.
export function Footer() {
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch("/v1/version")
      .then((r) => (r.ok ? r.json() : null))
      .then((data: { version?: string } | null) => {
        if (cancelled) return;
        const v = data?.version?.trim();
        if (!v || v === "dev") return;
        setVersion(v.startsWith("v") ? v : `v${v}`);
      })
      .catch(() => {
        /* silently degrade — leave hidden */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!version) return null;

  return (
    <div className="pointer-events-none fixed bottom-2 left-3 select-none font-mono text-[10px] text-muted-foreground/40">
      {version}
    </div>
  );
}

export default Footer;
